import {
  TableCell,
  Checkbox,
  CheckboxProps,
  FormControlLabel,
} from "@mui/material";

export function CheckboxCell({
  onClick,
  onChange,
  checked,
  ariaLabel,
}: {
  onClick: CheckboxProps["onClick"];
  onChange: CheckboxProps["onChange"];
  checked: boolean;
  ariaLabel?: string;
}) {
  return (
    <TableCell width={50}>
      <FormControlLabel
        control={
          <Checkbox
            {...{ onClick, onChange, checked }}
            {...(ariaLabel && {
              slotProps: { input: { "aria-label": ariaLabel } },
            })}
          />
        }
        label=""
        onClick={(e) => e.stopPropagation()}
      />
    </TableCell>
  );
}
